import { inject } from '@angular/core';
import { EG_ASSISTANT_CONFIG, EgAssistantSession } from '@expertgroup/assistant';

/**
 * Asistentska sesija, ili `null` kad je asistent isključen.
 *
 * ⚠️⚠️ Zašto ovo postoji umesto `inject(EgAssistantSession, { optional: true })`: sesija je u biblioteci
 * `providedIn: 'root'`, pa je `optional` **ipak konstruiše** — a njen konstruktor traži `EG_ASSISTANT_CONFIG`,
 * koji domaćin registruje samo kad je asistent upaljen. „Opciono" tamo znači „preživi ako konstrukcija
 * uspe", što je tačno suprotno od onoga što nam treba.
 *
 * Zato se pita **konfiguracija**: nju daje domaćin, pa `optional` nad njom pošteno vraća `null`, i sesija se
 * traži tek kad postoji ono što joj treba.
 *
 * ⚠️ Ovo je zaobilaženje oblika biblioteke, ne rešenje. Pravo rešenje je da sesiju daje `provideEgAssistant`
 * umesto `providedIn: 'root'` — tada bi `optional` radio kako svi očekuju. To menja javnu površinu
 * `@expertgroup/assistant`, pa ne ide uz ovu ispravku.
 */
export function injectAssistantSession(): EgAssistantSession | null {
    return inject(EG_ASSISTANT_CONFIG, { optional: true }) ? inject(EgAssistantSession) : null;
}
